export const about = {
  greeting: 'Hi, I’m Rachel',
  headline: 'I started this site because I was tired of texting the same four friends',
  portrait:
    'https://cdn.magicpatterns.com/patterns/generated-images/fa907dec-51d2-48de-a819-d4f56748b19d.jpg',
  portraitAlt:
    'Rachel, the founder, sitting on a wooden bench above the coast in warm afternoon light',
  story: [
    'We moved here when my oldest was fourteen months old. I knew two people, one of whom was my husband, and I spent that first summer driving to playgrounds with no shade, showing up to storytimes that had been cancelled since 2019, and putting my kid in a swim class forty minutes away because I didn’t know there was one six blocks from our house.',
    'So I started writing it down. First in the notes app, then in a spreadsheet I kept sending to other moms, and eventually here. Nine years and two kids later it’s become the thing I wish someone had handed me on day one — not a list of everything in Santa Barbara, but the honest version, with the parking situation and whether there are bathrooms.',
    'Everything on this site has been visited by me or by a local parent I trust. If a place is beautiful but miserable with a toddler, I say so. If a program is expensive but genuinely worth it, I say that too.',
  ],
  promises: [
    {
      title: 'We go in person',
      body: 'Nothing gets written up from a website. If it’s on here, someone stood in the parking lot with a stroller and figured out where the bathrooms are.',
    },
    {
      title: 'Nobody buys a recommendation',
      body: 'Sponsors can buy a clearly labeled placement. They cannot buy their way onto a list or change what we say about them. Every sponsored block says so on its face.',
    },
    {
      title: 'We say when something isn’t worth it',
      body: 'The useful part of a local guide is the “skip this one” — so we include those, gently, with a reason.',
    },
    {
      title: 'We keep it current',
      body: 'Events are checked every Thursday. Every place page carries the date it was last verified, and if it’s stale, you can see that.',
    },
  ],
  money: {
    headline: 'How this site pays for itself',
    body: 'Being straightforward about this feels better than burying it in a footer. There are three ways, and none of them change what gets recommended.',
    streams: [
      {
        name: 'Sponsored placements',
        detail: 'Local businesses can sponsor a clearly labeled block on a relevant page. Always marked, never blended into a list.',
      },
      {
        name: 'Affiliate links',
        detail: 'A few product links in the SB Family Edit earn a small commission at no extra cost to you. We only link things we own.',
      },
      {
        name: 'Featured business interviews',
        detail: 'Paid, and labeled as such — but we only run them for businesses we’d recommend to a friend anyway.',
      },
    ],
  },
  numbers: [
    { value: '410+', label: 'places visited and written up' },
    { value: '9 years', label: 'raising kids in Santa Barbara' },
    { value: 'Every Thursday', label: 'the events calendar is checked by hand' },
    { value: '6,200', label: 'parents reading the Sunday note' },
  ],
}
